import { render } from "./StructuredDataPerson.vue?vue&type=template&id=3b67a6ff&ts=true"
import script from "./StructuredDataPerson.vue?vue&type=script&lang=ts"
export * from "./StructuredDataPerson.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/billygrossman.com/billygrossman.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__